export class Filter {
    field: string;
    op: string; // <,>,<=,>=,like,not like,=,!=
    value: string;

    constructor(field: string = '', op: string = '', value: string = '') {
        this.field = field;
        this.op = op;
        this.value = value;
    }
}
export class FilterList {
    filters: Filter[]; //  (filt1 and_or filt2) 
    and_or: string; // and, or

    constructor() {
        this.filters = [];
        this.and_or = 'and';
    }
}
export class Filters {
    filterLists: FilterList[]; // (filt1 and filt2) and_or (filt3 and filt4)
    and_or: string; // and, or

    constructor() {
        this.filterLists = [];
        this.and_or = 'and';
    }
}

export class LangOption {
    value: string;
    labelIt: string;
    labelEn: string;
    labelDe: string;
    labelEs: string;
    labelFr: string;

    constructor() {
        this.value = '';
        this.labelIt = '';
        this.labelEn = '';
        this.labelDe = '';
        this.labelEs = '';
        this.labelFr = '';
    }
}
